import { preCachePreferences } from '@fs/zion-preferences'
import preferenceKeys from '../person-page/preference-keys'

/*
 * FUTURE TODO:
 * As of 2023-10, we are pre-caching 20 individual preferences. The underlying backend user preferences service utilizes a redis cache, so tacking them all together is still faster than requesting everything individually. However, with zion-preferences architected around *individual* preferences, we do not have a clean way to just say LOAD_ALL_PREFERENCES=true. If this functionality is added, we can use it and stop itemizing, and just have a note that this application is very preference-heavy, and so it is faster to load everything into memory, and *then* pick out what we actually need.
 */

// Preferences that are utilized on more than one page or for the base application view itself.
const commonPreferences = [
  'fslabs.labs',
  'tree.cetTest',
  'tree.nameTemplate', // AddFindFlow, which can launch from recents on any page
  'tree.person-page.contrast-mode',
  'tree.person-page.dark-mode',
  'tree.showLDSTempleInfo',
  'tree.showNamesInRomanScript',
]

// Since the various person page preference keys are used all over the app, just map over them, instead of referencing each one individually.
const personPageSpecificPreferences = Object.keys(preferenceKeys).map((key) => preferenceKeys[key])

const timelineSpecificPreferences = ['tree.person-timeline-filter-options', 'tree.timelineMapOnState']

// These preferences are used on the specific sources page, but also when editing a conclusion, so we pre-cache them.
const sourcesSpecificPreferences = [
  'source-list.hide-unfinished-attachments',
  'source-list.sort-direction',
  'source-list.sort',
]

const temporaryPreferences = ['tree.showMyPrivateTreeOverlay']

// NOTE: Memories does not appear to utilize zion-preferences, so we cannot cache these preferences: `memories.treePerson.sort` & `memories.userAgreement`

// Preload all noteworthy preferences to speed up pageloads.
export default function usePreloadPreferences(): void {
  preCachePreferences(
    ...commonPreferences,
    ...personPageSpecificPreferences,
    ...sourcesSpecificPreferences,
    ...timelineSpecificPreferences,
    ...temporaryPreferences
  )
}
